module.exports = __webpack_public_path__ + "static/img/mp1_md.7eba0cc.png";